import { render, staticRenderFns } from "./VendorValidation.vue?vue&type=template&id=06eac37b"
import script from "./VendorValidation.vue?vue&type=script&lang=js"
export * from "./VendorValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports